import styled from "styled-components";
import breakpoint from "../../../assets/breakpoints";
import { Avatar } from "react-rainbow-components";

export const ContainerCard = styled.div`
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.01);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  margin: 2rem;
  overflow: hidden;
  @media only screen and ${breakpoint.device.sm} {
    margin: 0;
  }
`;

export const HeaderChat = styled.div`
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
`;

export const ImageAvatar = styled(Avatar)`
  width: 2rem !important;
  height: 2rem !important;
  border-radius: 999px;
  margin: 0rem 1rem;
`;

export const ButtonBack = styled.div`
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  transition: all 0.5s ease;
  &:hover {
    transition: all 0.5s ease;
    transform: scale(1.2);
  }
  display: flex;
  justify-content: center;
  align-items: center;
`;
